module.exports = __webpack_public_path__ + "static/media/arrowback.70a5391d.svg";